import React from 'react';

interface WatermarkProps {
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
}

const Watermark: React.FC<WatermarkProps> = ({ position = 'bottom-right' }) => {
  const positionStyles: Record<string, React.CSSProperties> = {
    'bottom-right': { bottom: 32, right: 16 },
    'bottom-left': { bottom: 32, left: 16 },
    'top-right': { top: 32, right: 16 },
    'top-left': { top: 32, left: 16 },
  };

  return (
    <div
      style={{
        position: 'fixed',
        ...positionStyles[position],
        color: 'rgba(255, 255, 255, 0.15)',
        fontSize: '12px',
        fontWeight: 500,
        letterSpacing: '1px',
        pointerEvents: 'none',
        userSelect: 'none',
        zIndex: 9999,
      }}
    >
      BDP vLab
    </div>
  );
};

export default Watermark;
